import { useQuery } from '@hooks/reactQuery';

import { getDownloadHistorySources } from '@api/downloadHistory';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { allowedRolesDownloadHistory } from '@constants/downloadHistory';
import { DOWNLOAD_HISTORY_SOURCES } from '@constants/queryKeys';

interface UseQueryDownloadHistorySources {
	sourcesOptions: TSelectOption<string>[];
	isLoadingSourcesOptions: boolean;
}

export const useQueryDownloadHistorySources = (): UseQueryDownloadHistorySources => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [DOWNLOAD_HISTORY_SOURCES],
		allowedRoles: allowedRolesDownloadHistory,
		queryFn: getDownloadHistorySources,
		select: nameTitleToOptionFormatted,
		...refetchOptions,
	});

	return {
		sourcesOptions: data || [],
		isLoadingSourcesOptions: (isLoading && !!data)
			|| isFetching,
	};
};
